import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { useTranslations } from 'modules/creativeLibrary/hooks/useTranslations';
import { ALT_TEXT_MAX_LENGTH } from 'modules/creativeLibrary/constants';

export type AltTextInputProps = {
  /** The current alt text value */
  value: string;
  /** Callback function when the alt text changes */
  onChange: (value: string) => void;
  /** Whether to show the description text and character count */
  showDescription?: boolean;
  /** Optional data-test attribute for testing */
  dataTest?: string;
  /** Optional input id, defaults to 'asset-form-alt-text' */
  inputId?: string;
};

export const AltTextInput = ({
  value,
  onChange,
  showDescription = false,
  dataTest,
  inputId = 'asset-form-alt-text',
}: AltTextInputProps) => {
  const { t } = useTranslations();

  return (
    <FormField
      inputId={inputId}
      labelText={t('input.altText.label')}
      restrictionText={
        showDescription ? `${value.length}/${ALT_TEXT_MAX_LENGTH} characters` : undefined
      }
      descriptionText={showDescription ? t('input.altText.description') : undefined}
    >
      <InputText
        data-test={dataTest}
        id={inputId}
        onChange={onChange}
        type="text"
        value={value}
        maxLength={ALT_TEXT_MAX_LENGTH}
      />
    </FormField>
  );
};
